import { withJsonFormsControlProps } from "@jsonforms/react";
import { t } from "i18next";
import { TextInput } from "pepsico-ds";

function ProfileStatusLabel({ data }) {
  const profileStatus = data;
  const statusLabel =
    profileStatus === "Anonymize"
      ? t("CustomerSupport:AnonymizedButton")
      : profileStatus === "Deleted"
        ? t("CustomerSupport:RequestedForAnonymizationButton")
        : profileStatus;

  return (
    <TextInput
      className="font-sm"
      value={statusLabel}
      disabled={true}
      label={t("CustomerSupport:ProfileStatusLabel")}
    />
  );
}

export const ProfileStatusLabelControl =
  withJsonFormsControlProps(ProfileStatusLabel);
